import type { GameState, Puzzle } from '../types';
import { CHILL_KEY } from './constants';

export function createState(puzzle: Puzzle): GameState {
  return {
    puzzle,
    guesses: [],
    current: '',
    status: 'playing',
    chillMode: readChillMode(),
    dripStartedAt: null,
  };
}

function readChillMode(): boolean {
  try {
    return localStorage.getItem(CHILL_KEY) === '1';
  } catch {
    return false;
  }
}
